
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1318Dialog extends Serenity.EntityDialog<Report_1318Row, any> {
        protected getFormKey() { return Report_1318Form.formKey; }
        protected getIdProperty() { return Report_1318Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1318Row.localTextPrefix; }
        protected getNameProperty() { return Report_1318Row.nameProperty; }
        protected getService() { return Report_1318Service.baseUrl; }
        protected getDeletePermission() { return Report_1318Row.deletePermission; }
        protected getInsertPermission() { return Report_1318Row.insertPermission; }
        protected getUpdatePermission() { return Report_1318Row.updatePermission; }

        protected form = new Report_1318Form(this.idPrefix);

    }
}